import React from 'react';

import {Alert} from '@ui';

export const ClientDrmSetupNoDrmMessage = () => {
    return (
        // TODO: Proper MUI icon should be added
        <Alert severity='info' >
            No DRM setup has been defined for this client. If you want to define one, start by selecting a DRM provider.
        </Alert>
    );
};

ClientDrmSetupNoDrmMessage.displayName = 'NoDrmMessage';
